import _ from "lodash";
/**
 * Selection Service
 *
 * Utility functions for resolving selections with local storage values.
 */
export default {
	//Wrappers for getting and setting from $ls since it doesn't handle raw JSON objects
	set(vue, key, value) {
		vue.$ls.set(key, JSON.stringify(value));
	},

	get(vue, key) {
		let val = vue.$ls.get(key);
		return val != "undefined" && JSON.parse(val);
	},

	getDefault(vue, key, defaultVal) {
		let val = this.get(vue, key);
		if (val == null || val == undefined) {
			return defaultVal;
		} else {
			return val;
		}
	},

	//2-way bind a value
	//Equivalent to calling 'getDefault' on the key and also setting a watch to 'set' it on change
	bind(vue, localKey, storeKey, defaultVal) {
		if (!storeKey) {
			vue.storagePrefix = vue.storagePrefix || "";
			storeKey = vue.storagePrefix + localKey;
		}

		vue.$watch(localKey, () => {
			this.set(vue, storeKey, vue[localKey]);
		});
		return this.getDefault(vue, storeKey, defaultVal);
	},

	//Resolve a value from a given list
	//Param 'compBy' determines the field in the list element that needs to match the stored element
	//Param 'defaultIndex' determines what element of the list is returned if there's no store value
	resolveFromList(vue, list, compBy, defaultIndex, key) {
		var stored = this.get(vue, key);
		var resolved;
		if (stored) {
			resolved = _.find(list, el => {
				return el[compBy] == stored;
			});
		}

		if (resolved) {
			return resolved;
		} else if (defaultIndex != null && list) {
			return list[defaultIndex];
		} else {
			return null;
		}
	},

	//2-way bind a value from an input list
	//Equivalent to calling 'resolveFromList' and setting a watch
	bindFromList(vue, list, compBy, defaultIndex, localKey, storeKey) {
		if (!storeKey) {
			vue.storagePrefix = vue.storagePrefix || "";
			storeKey = vue.storagePrefix + localKey;
		}

		vue.$watch(
			localKey,
			() => {
				if (vue[localKey] == null) {
					this.set(vue, storeKey, vue[localKey]);
				} else {
					this.set(vue, storeKey, vue[localKey][compBy]);
				}
			},
			{ deep: true }
		);
		return this.resolveFromList(vue, list, compBy, defaultIndex, storeKey);
	},
};
